__turbopack_context__.v({
  "opacityTransition": "Tooltip-module__aXSOkq__opacityTransition",
  "opacityTransitionOpen": "Tooltip-module__aXSOkq__opacityTransitionOpen",
  "spyElement": "Tooltip-module__aXSOkq__spyElement",
  "tooltipContent": "Tooltip-module__aXSOkq__tooltipContent",
});
